import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=1d8899d3"
import script from "./NoteModal.vue?vue&type=script&lang=ts"
export * from "./NoteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports